import { QuestionFlowEnum } from '@strata-monorepo/shared-types'

export interface ProgressDisplayConfig {
  mode: 'step' | 'percentage'
  showSteps: boolean
  showProgressBar?: boolean
}

export const progressDisplayConfig: Record<QuestionFlowEnum, ProgressDisplayConfig> = {
  [QuestionFlowEnum.QUICK]: { mode: 'step', showSteps: true },
  [QuestionFlowEnum.DEEP_DIVE]: { mode: 'percentage', showSteps: false },
}

const defaultProgressDisplayConfig: ProgressDisplayConfig = { mode: 'percentage', showSteps: false }

export const getProgressDisplayConfig = (interstitial: unknown): ProgressDisplayConfig => {
  if (typeof interstitial !== 'string') return defaultProgressDisplayConfig
  return progressDisplayConfig[interstitial as QuestionFlowEnum] ?? defaultProgressDisplayConfig
}
